/**
 * SEO for the marketing unsubscribe confirm page (`/unsubscribe/marketing`).
 */

import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { absoluteUrlForPath } from '@web/src/lib/utilsClient'

export function marketingUnsubscribePageHead() {
  const pageUrl = absoluteUrlForPath('/unsubscribe/marketing')

  return seo({
    title: `Unsubscribe from marketing emails | ${env.VITE_APP_NAME}`,
    description: 'Confirm that you want to stop receiving Spicy Friends product updates and marketing emails.',
    url: pageUrl,
    robots: robotsMetaForEnvironment({ all: 'noindex,nofollow' }),
  })
}
